import { render, staticRenderFns } from "./BookChildProductBox.vue?vue&type=template&id=f94ec4b4&scoped=true&"
import script from "./BookChildProductBox.vue?vue&type=script&lang=js&"
export * from "./BookChildProductBox.vue?vue&type=script&lang=js&"
import style0 from "./BookChildProductBox.vue?vue&type=style&index=0&id=f94ec4b4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f94ec4b4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\other\\DaMou-Frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f94ec4b4')) {
      api.createRecord('f94ec4b4', component.options)
    } else {
      api.reload('f94ec4b4', component.options)
    }
    module.hot.accept("./BookChildProductBox.vue?vue&type=template&id=f94ec4b4&scoped=true&", function () {
      api.rerender('f94ec4b4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/訂單流程/BookChildProductBox.vue"
export default component.exports